// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.my-form-class[data-v-25e53a65] {\n  margin-bottom: -15px !important;\n}\n", ""]);
// Exports
module.exports = exports;
